/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { TableCell } from './TableCell';
const TableBody = ({ data, columns }) => (React.createElement(React.Fragment, null, data.map((row, i) => (React.createElement("tr", { key: `row-${row.id}-${i}` }, columns.map(c => React.createElement(TableCell, { key: `cell-${row.id}-${i}-${c.accessor}`, column: c, row: row })))))));
export { TableBody, };
